module.exports = __webpack_public_path__ + "img/jonas-pregartner.7b44bab4.jpg";